module.exports = __webpack_public_path__ + "assets/img_birite.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_birite.jpg
 ** module id = 118
 ** module chunks = 1
 **/